import { Card, Chip, Grid2, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IZoneSchedule } from "../../../../../Domain/Types/FloorPlan/ZoneSchedule";
import { RemoteCateringMenu } from "../../../../../../ServiceManagement/Catering/Domain/Types/Remote-CateringMenu.types";
import {
  AssignedCateringMenu,
  CateringMenuIds
} from "../../../../../Domain/Types/FloorPlan/CateringMenuAssignment.type";
import ServiceCateringMenuTable from "./CateringMenuTable";

type Props = {
  zoneSchedule: IZoneSchedule;
  allCateringServices: RemoteCateringMenu[] | undefined;
  assignedCateringItems: AssignedCateringMenu[];
  onChangeConfService: (id: number, service: { cateringServices: CateringMenuIds[] }) => void;
  onClose: () => void;
};

export const CateringMenuDialogContent = ({
  zoneSchedule,
  allCateringServices,
  assignedCateringItems,
  onChangeConfService,
  onClose
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      sx={{ p: 2, width: "75vw", overflow: "auto", maxHeight: "80%", backgroundImage: "unset" }}
      data-testid={"catering-menu-assignment-card"}
    >
      <Stack direction={"column"} gap={2}>
        {/* header of dialog content */}
        <Grid2 container display={"grid"} data-testid="catering-menu-dialog-content-header">
          <Grid2 container sx={{ display: "flex", alignItems: "center" }} columnGap={2}>
            <Typography align={"left"} sx={{ lineHeight: 2.5 }} variant={"h6"}>
              {t("CateringDialogContentTitle")}
            </Typography>
            <Chip label={zoneSchedule.inventory?.name ?? "Zone"} />
          </Grid2>
          <Typography align={"left"} sx={{ lineHeight: 2 }} variant={"subtitle2"}>
            {t("CateringDialogContentSubTitle")}
          </Typography>
        </Grid2>

        {/* parent element of display and select options */}
        <Grid2
          container
          data-testid="catering-menu-assignment-parentEl"
          alignSelf={"center"}
          sx={{ width: "100%", maxHeight: "80vh" }}
        >
          <ServiceCateringMenuTable
            zoneSchedule={zoneSchedule}
            allCateringServices={allCateringServices}
            assignedCateringItems={assignedCateringItems}
            onClose={onClose}
            onChangeConfService={onChangeConfService}
          />
        </Grid2>
      </Stack>
    </Card>
  );
};
